export type DeviceType = "ios" | "android" | "desktop" | "unknown"

export default function useDeviceType(): DeviceType {
  const ua = navigator.userAgent

  if (/iPad|iPhone|iPod/.test(ua)) return "ios"
  if (/Android/.test(ua)) return "android"
  if (/Mobi|webOS|BlackBerry|Opera Mini|IEMobile/.test(ua)) return "unknown"

  return "desktop"
}
